import Blank from "../components/blank";
import styles from "../index.less";
import { clearHtmlTag } from "utils";
import { useEffect, useState } from "react";
import { recommendContentDiag } from "api/doctor-list";
import evaluate5 from "../../../asset/img/login/evaluate5.png";
import icon_right from "../../../asset/img/login/icon_right.png";
import Pagination from "../components/pagination";
import { departNav, hospitalNav } from "utils/hospital";
import { queryRecommendArticles } from "api/hospital";


/**
 * 
 * @param showAll 控制是否有分页，是否默认展示全部 
 * @returns 
 */

const ArticleList = ({ tabIndex, initData, pageId, showAll, current, name, departId }: any) => {
  const moreUrl = departId ? departNav(`${pageId}-${departId}`)[tabIndex]?.url : hospitalNav(pageId)[tabIndex]?.url;
  const [contentOtherArt, setContentOtherArt] = useState<any>();
  const [contentIndex, setContentIndex] = useState<number>(3);
  const [nextPage, setNextPage] = useState<boolean>(false);
  const [pageNo, setPageNo] = useState<number>(current);
  useEffect(() => {
    getContent(pageId);
  }, []);
  // 推荐文章
  const getContent = (hospitalId: any) => {
    let allParam = {};
    if(showAll){
      allParam = {
        sortOrderParams: [{
          field: "createTime",
          order: "desc"
        }],
        contentTypes: [1, 7],
        contentStatus: [1],
      }
    }
    
    // 其他文章
    (showAll ? recommendContentDiag({
      osName: "content",
      tenantId: 287,
      version: 13,
      methodName: showAll ? "queryContents450" : "recommendContentArticle428",
      floorId: 5092,
      appId: "c59cb704c24245a58768efa1ca1b4940",
      pageSize: 10,
      authors: [{
        authorType: 7,
        hospitalId,
        // departId: 6,
        secondDepartId: departId,
      }],
      ...allParam,
      pageNo: current,
    }) : queryRecommendArticles({
      tenantId: 287,
      pageSize: 10,
      authors: [{
        authorType: 7,
        hospitalId,
        // departId: 6,
        secondDepartId: departId,
      }],
      ...allParam,
      pageNo: current,
    })).then((res: any) => {
      if (!showAll) {
        setContentOtherArt(res);
        return;
      }
      setContentOtherArt(res.data);
      setNextPage(res.pageNo < res.totalPage || false);
      setPageNo(res.pageNo || 1);
    });
  }
  if(!contentOtherArt?.length){
    return null;
  }
  return <Blank className={styles.articleList} title={`${name || ''}科普文章`} moreUrl={moreUrl}>
  {contentOtherArt && contentOtherArt?.length > 0 ? (
    <>
      <ul>
        {contentOtherArt.map((itme: any, index: any) => {
          return (
            <li
              key={index}
              onClick={() => {
                window.open(
                  window.location.origin +
                    "/pccontent/" +
                    itme?.contentId
                );
              }}
              className={!showAll && index >= contentIndex ? styles.displayNone : ''}
            >
              <div className={styles.articleImg}>
                {itme.titlePicUrl && (
                  <img
                    src={
                      itme.titlePicUrl && itme.titlePicUrl?.startsWith?.('http') ? itme.titlePicUrl :
                      "https://image.healthjd.com/nethpim/" +
                      itme.titlePicUrl
                    }
                    alt=""
                    className={styles.articleImg1}
                  />
                )}
                <div className={styles.articleWidth}>
                  <div className={styles.articleListTop}>
                    <div
                      className={styles.articleListTopText}
                      data-tag-h2
                      data-a-href={
                        "/pccontent/" +
                        itme?.contentId
                      }
                    >
                      {itme?.contentName}
                    </div>
                    <div className={styles.articleListTopInfo}>
                      <span>点击查看</span>
                      <img src={icon_right} alt="" />
                    </div>
                  </div>
                  <div className={styles.consultationListBon}>
                    <div className={styles.consultationListBonLeft}>
                      <div
                        className={styles.consultationListBonLeftText1}
                      >
                        {itme?.contentParagraphs &&
                          itme?.contentParagraphs?.length > 0 &&
                          itme?.contentParagraphs[0]
                            ?.paragraphContent && (
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: clearHtmlTag(
                                  itme?.contentParagraphs[0]
                                    .paragraphContent
                                ),
                              }}
                            ></h3>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      {/* 展开更多 */}
      { !showAll &&
        <div className={styles.evaluateListMore}>
          <p
            onClick={() => {
              if (contentIndex <= 3) {
                setContentIndex(10);
              }
            }}
          >
            {initData &&
              contentIndex <= 3 ? (
              <>
                <span>展开更多</span>
                <img src={evaluate5} alt="" />
              </>
            ) : null}
          </p>
        </div>
      }
      {/* 分页 */}
      { showAll && 
        <Pagination
          pageId={pageId}
          current={current}
          nextPage={nextPage}
          nextUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${pageNo+1}/articlelist`}
          preUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${pageNo-1}/articlelist`}
        />
      }
    </>
  ) : <div className={styles.noData}>暂无科普文章</div>
  }
</Blank>
}

export default ArticleList;